const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/site',
    unAuthenticatedEntryPath: '/sign-up',
    tourPath: '',
    enableMock: false
}

export default appConfig